import { getName, getStudentClass } from '@/utils/studentUtils';

export const NAVBAR_LEARNER_RESULT_LIMIT = 8;

const normalize = (value) => String(value || '').trim().toLowerCase();

export const findLearners = (students, query, limit = NAVBAR_LEARNER_RESULT_LIMIT) => {
  const needle = normalize(query);
  if (!needle) return [];

  const terms = needle.split(/\s+/).filter(Boolean);

  return (Array.isArray(students) ? students : [])
    .map((student) => {
      const name = getName(student);
      const className = getStudentClass(student);
      const normalizedName = normalize(name);
      const haystack = `${normalizedName} ${normalize(className)}`;

      if (!terms.every((term) => haystack.includes(term))) return null;

      let score = 0;
      if (normalizedName === needle) score = 400;
      else if (normalizedName.startsWith(needle)) score = 300;
      else if (normalizedName.split(/\s+/).some((part) => part.startsWith(needle))) score = 200;
      else if (normalizedName.includes(needle)) score = 100;

      return { student, name, className, score };
    })
    .filter(Boolean)
    .sort((a, b) => b.score - a.score || a.name.localeCompare(b.name))
    .slice(0, limit);
};
